import { render, staticRenderFns } from "./PermissionsForm.vue?vue&type=template&id=cf1fc018&scoped=true&lang=pug&"
import script from "./PermissionsForm.vue?vue&type=script&lang=ts&"
export * from "./PermissionsForm.vue?vue&type=script&lang=ts&"
import style0 from "./PermissionsForm.vue?vue&type=style&index=0&id=cf1fc018&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf1fc018",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VBtn,VCardText,VCheckbox})
